import * as React from 'react';
import { ISvgAtomProps } from './Atoms.interfaces';

const PreviouslyPurchasedChip: React.FC<ISvgAtomProps> = ({ width = 80, height = 12 }) => {
  return (
    <svg x={0} y={0} width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <rect x={0} y={0} width={width} height={height} rx={4} fill="#e9ecef" />
      <text x={10} y={height / 2} textAnchor="start" dominantBaseline="middle" fill="#666" fontSize={8}>
        Past Purchased
      </text>
    </svg>
  );
};

export default PreviouslyPurchasedChip;
